import { render, staticRenderFns } from "./campaignPlate.vue?vue&type=template&id=488ad5ec&"
import script from "./campaignPlate.vue?vue&type=script&lang=js&"
export * from "./campaignPlate.vue?vue&type=script&lang=js&"
import style0 from "./campaignPlate.vue?vue&type=style&index=0&id=488ad5ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports